import { createInteractor } from './interactor';
import { createView } from './view';
import { combineSubscriptions } from '@updater-core/lib/store/utils/combine';
import { present } from './presenter';
import { log } from './logger';

export const build = ({ container, interactors, excludeLinkCodes }) => {
  const initialState = { excludeLinkCodes };
  const footer = createInteractor({ interactors, initialState });
  const subscriptionStream = combineSubscriptions({
    session: interactors.session,
    journey: interactors.journey,
    siteBranding: interactors.siteBranding,
    footer,
  });
  const view = createView({ container });
  const disconnect = subscriptionStream.connect((state) => {
    const presenterInterface = present(state, interactors);
    log('presenter:', presenterInterface);
    view.render({
      state: presenterInterface,
    });
  });
  return {
    destroy: () => {
      disconnect();
      view.destroy();
      footer.destroy();
    },
  };
};
